import { render, staticRenderFns } from "./creative.vue?vue&type=template&id=197cc12c"
import script from "./creative.vue?vue&type=script&lang=js"
export * from "./creative.vue?vue&type=script&lang=js"
import style0 from "./creative.vue?vue&type=style&index=0&id=197cc12c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports